// @flow

import styled from 'styled-components';
import { colors } from 'shared/styleguide';

export default styled.div`
  border-bottom: 2px solid ${colors.paleGrey};
`;
